export default "__VITE_ASSET__Bg2ApAg5__"